import React from "react";
import { Link } from "react-router-dom";
import { LogoWrapper } from "./Logo.style";

// const partnerId = process.env.REACT_APP_SITE_ID || "";

export const Logo: React.FC = () => {
  const logoSrc = "/assets/poupas_logo_w.svg";

  return (
    <LogoWrapper>
      <Link to="/">
        <img src={logoSrc} alt="" />
      </Link>
    </LogoWrapper>
  );
};
